import { render, staticRenderFns } from "./YoutubeBanner.vue?vue&type=template&id=4054d03c&scoped=true&"
import script from "./YoutubeBanner.vue?vue&type=script&lang=js&"
export * from "./YoutubeBanner.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeBanner.vue?vue&type=style&index=0&id=4054d03c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4054d03c",
  null
  
)

export default component.exports